// tripExpenseApi.ts - Version améliorée avec gestion d'erreurs

import axios from 'axios';

const api = axios.create({ baseURL: import.meta.env.VITE_API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Intercepteur de réponse pour logger les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      config: {
        method: error.config?.method,
        url: error.config?.url,
        data: error.config?.data
      }
    });
    return Promise.reject(error);
  }
);

export interface TripExpensePayload {
  tripId: string;
  type: 'fuel' | 'toll' | 'other';
  amount: number;
  note?: string | null;
  date: string;
}

export const listTripExpenses = async (tripId?: string) => {
  try {
    const { data } = await api.get('/api/trip-expenses', { 
      params: tripId ? { tripId } : {} 
    });
    return data as any[];
  } catch (error) {
    console.error('Error fetching trip expenses:', error);
    throw error;
  }
};

export const createTripExpense = async (payload: TripExpensePayload) => {
  try {
    console.log('Creating trip expense with payload:', payload);
    const { data } = await api.post('/api/trip-expenses', payload);
    console.log('Trip expense created successfully:', data);
    return data;
  } catch (error) {
    console.error('Error creating trip expense:', error);
    throw error;
  }
};

export const updateTripExpense = async (id: string, payload: Partial<TripExpensePayload>) => {
  try {
    console.log('Updating trip expense:', id, payload);
    const { data } = await api.patch(`/api/trip-expenses/${id}`, payload);
    return data;
  } catch (error) {
    console.error('Error updating trip expense:', error);
    throw error;
  }
};

export const deleteTripExpense = async (id: string) => {
  try {
    await api.delete(`/api/trip-expenses/${id}`);
  } catch (error) {
    console.error('Error deleting trip expense:', error);
    throw error;
  }
};

export const exportTripExpenses = async (params: Record<string, any> = {}, file: 'csv'|'xlsx'|'pdf'='csv') => {
  const res = await api.get('/api/trip-expenses/export', { params: { ...params, file }, responseType: 'blob' });
  const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/octet-stream' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  const filename = (res.headers['content-disposition'] || '').split('filename=')[1]?.replace(/"/g,'') || `trip-expenses.${file}`;
  a.href = url; a.download = filename; a.click(); URL.revokeObjectURL(url);
};